import { useTranslation } from 'react-i18next';

const ConfirmView = () => {
  const { t } = useTranslation();

  return <div dangerouslySetInnerHTML={{ __html: t('pages.purchase.confirm-receiving-item') }} />;
};

export default ConfirmView;
